import PriceTargetOutline from '@simplywallst/ui-core/icons/PriceTargetOutline';
import WarrenSolid from '@simplywallst/ui-core/icons/WarrenSolid';

import { NarrativeAuthorAvatar } from '@/components/NarrativeAuthor';

type Props = {
  type: string;
  author?: {
    displayName: string | null;
    imageUrl: string | null;
    name: string;
  };
};

export const PrimaryNarrativeIcon = ({ type, author }: Props) => {
  const className =
    'grid relative items-center content-center justify-center overflow-hidden rounded-full bg-p-grey-10 w-6 h-6';
  if (type === 'dcf') {
    return (
      <div className={className}>
        <WarrenSolid className="w-5" aria-label="discounted-cash-flow" />
      </div>
    );
  }

  if (type === 'analysts') {
    return (
      <div className={className}>
        <PriceTargetOutline
          className="w-6 fill-accent"
          aria-label="analyst-price-target"
        />
      </div>
    );
  }

  if (type === 'user_defined' && author) {
    return <NarrativeAuthorAvatar author={author} size="sm" />;
  }

  return null;
};
